import React, { Suspense } from 'react';
import './styles/global.scss';
import './assets/css/theme.css';
import LayoutContainer from './layouts/layout.container';
import { Switch, Router } from 'react-router-dom';
import browserHistory from './browserHistory';
import {
    AuthProvider,
    BalanceProvider,
    ChatBotProvider,
    useGlobalStateContext,
    MerchantCreationProvider
} from 'contexts';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import withoutSideBarMerchantRoutes from './routing/without-sidebar.routes';
import withoutSideBarMerchantCustomDomainRoutes from './routing/without-sidebar.custom-domain.routes';
import Maintainance from 'pages/under-maintainance/under-maintainance.container';
import { randomStringWithLength } from 'utils/helper';

//
const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#43425d',
            light: '#73729a'
        },
        error: {
            main: '#f44336',
            light: '#f44336'
        },
        success: {
            main: '#4caf50',
            light: '#f44336'
        }
    }
});

function App() {
    React.useEffect(() => {
        if (!localStorage.getItem('deviceId')) {
            if (navigator?.geolocation?.getCurrentPosition) {
                navigator.geolocation.getCurrentPosition((res) => {
                    localStorage.setItem('longitude', res.coords.longitude);
                    localStorage.setItem('latitude', res.coords.latitude);
                });
            }
            localStorage.setItem('deviceName', navigator.userAgent);
            localStorage.setItem('deviceId', randomStringWithLength(20));
        }
    }, []);
    // eslint-disable-next-line
    const { globalState } = useGlobalStateContext();
    return (
        <AuthProvider>
            <ChatBotProvider>
                <BalanceProvider>
                    <MerchantCreationProvider>
                        <MuiThemeProvider theme={theme}>
                            <Router history={browserHistory}>
                                <Suspense fallback={null}>
                                    <Switch>
                                        {JSON.parse(localStorage.getItem('customDomain')) === false ? (
                                            withoutSideBarMerchantRoutes
                                        ) : globalState.maintainance ? (
                                            <Maintainance />
                                        ) : (
                                            withoutSideBarMerchantCustomDomainRoutes
                                        )}
                                        <LayoutContainer />
                                    </Switch>
                                </Suspense>
                            </Router>
                        </MuiThemeProvider>
                    </MerchantCreationProvider>
                </BalanceProvider>
            </ChatBotProvider>
        </AuthProvider>
    );
}

export default App;
